import React, { useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import Button from '../../common/Button';
import { redirectToNetSuite } from '../../../store/actions/integrations';
import SimpleInput from '../../common/SimpleInput/SimpleInput';
import { InfoTooltip } from '../../common/InfoTooltip';
import { Note } from '../../common/Note';

import styles from '../ConnectForm.module.scss';

export function ConnectNetSuiteForm() {
  const dispatch = useDispatch();
  const [accountId, setAccountId] = useState('');
  const [locationId, setLocationId] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const submit = (e) => {
    setSubmitting(true);
    dispatch(redirectToNetSuite(accountId, locationId));
    e.preventDefault();
  };

  const isDisabled = useMemo(() => {
    return submitting || accountId === '' || locationId === '';
  }, [submitting, accountId, locationId]);

  return (
    <form className={styles.form} onSubmit={submit}>
      <div className={styles.body}>
        <label>
          Enter your Account ID:
          <span className={styles.mandatory}>*</span>
          <InfoTooltip
            width={520}
            content={
              <>
                <p>This is the NetSuite Account ID for your company.</p>
                <p>
                  To find the <strong>Account ID</strong> - Go to <strong>Setup</strong> &gt; <strong>Company</strong>{' '}
                  &gt; <strong>Company Information</strong> &gt; <strong>Account ID</strong>.
                </p>
                <p>Example: "1234567".</p>
              </>
            }
          />
        </label>
        <SimpleInput
          value={accountId}
          onChange={(e) => {
            setAccountId(e.target.value);
            setSubmitting(false);
          }}
        />
        <label>
          Enter your Location ID:
          <span className={styles.mandatory}>*</span>
          <InfoTooltip
            width={500}
            content={
              <>
                <p>
                  Locations can be used to identify and categorize records in your NetSuite account. You can also define
                  locations for your organization's needs by creating custom segments. Locations enable you to better
                  organize data and preserve accuracy.
                </p>
                <p>
                  For information about working with locations in the UI, go to{' '}
                  <strong>Help Center - Classifications</strong> in NetSuite.
                </p>
                <p>
                  To find the <strong>Location ID</strong> - Go to <strong>Setup</strong> &gt; <strong>Company</strong>{' '}
                  &gt; <strong>Classifications</strong> &gt; <strong>Locations</strong>.
                </p>
                <p>Example: "1".</p>
              </>
            }
          />
        </label>
        <SimpleInput
          value={locationId}
          onChange={(e) => {
            setLocationId(e.target.value);
            setSubmitting(false);
          }}
          focus={false}
        />
        <p>This will redirect you to NetSuite's site to connect Cymbio as an integration.</p>

        <Note>
          <strong>NOTE:</strong> You can find the Connection Guidelines on{' '}
          <a target="_blank" href="https://www.cym.bio/netsuite-integration/" rel="noreferrer">
            Cymbio Website
          </a>
          .
        </Note>
      </div>

      <div className={styles.footer}>
        <div className={styles.button}>
          <Button type="submit" text="Continue" loading={submitting} disabled={isDisabled} />
        </div>
      </div>
    </form>
  );
}
